import { selectConnectionStatus } from './spectrasWebSocketServerSlice';
import { Typography } from '@mui/material';
import { green } from '@mui/material/colors';
import { useAppSelector } from '../../app/hooks';

const ConnectionStatus = () => {
  const connectionStatus = useAppSelector(selectConnectionStatus);

  return (
    <Typography
      color={connectionStatus ? green[500] : 'error'}
      variant='subtitle2'
    >
      {connectionStatus ? 'Connected' : 'Lost Connection'}
    </Typography>
  );
};

export default ConnectionStatus;
